import React, { PropsWithChildren, useEffect } from 'react'
import { InformationalError, useShowError } from '@aserto/console-common'

import { useInfo } from '../../api/info'

const ServiceInfoProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isError } = useInfo()
  const showError = useShowError()

  useEffect(() => {
    if (isError) {
      showError(
        new InformationalError(
          'To discuss how to migrate to Topaz, engage with the maintainers on the Community Slack at https://www.aserto.com/slack.',
          'The Aserto hosted platform has been retired as of May 31, 2025'
        )
      )
    }
  }, [isError, showError])

  return isError ? null : <>{children}</>
}

export default ServiceInfoProvider
